var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dropdown',{attrs:{"options":_vm.options,"label":_vm.label,"rounded":_vm.rounded,"placeholder":_vm.placeholder,"value":_vm.modelValue,"bottom-bar":_vm.bottomBar,"clearable":""},on:{"input":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }